export default __webpack_public_path__ + "d77cd7a4fea8c37d7dc37e7bbe069b5e.png";